import { axiosInstance } from "../../../helper"
import { event } from "../types"

export function nextEvents(params, config) {
	return {
		type: event.NEXT_EVENTS,
		payload: new axiosInstance.get("/admin/event", {
			...config,
			params,
		}),
	}
}

export default nextEvents
